function territories(state = {}, action) {
    switch(action.type) {
        case 'TERRITORIES_FETCH_START':
            return {
                data : {},
                fetching : true,
                error : null,
            }
        case 'TERRITORIES_FETCH_SUCCESS':
            return {
                data : action.data,
                fetching : false,
                error : null,
            }
        case 'TERRITORIES_FETCH_FAILURE':
            return {
                data : {},
                fetching : false,
                error : action.error,   
            }
        default :
            return state;        
    }
}


export default territories;


/** WEBPACK FOOTER **
 ** ./src/reducers/territories.js
 **/